import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

function useCountUp(target, duration = 1800, trigger = true) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    let start = 0;
    const startTime = performance.now();
    const step = (t) => {
      const p = Math.min((t - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * (target - start) + start));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, trigger]);
  return val;
}

function Card({ year, value, label, highlight, inView, delay }) {
  const n = useCountUp(value, 1600, inView);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ delay, duration: 0.6 }}
      className={`relative p-8 md:p-10 rounded-2xl border ${
        highlight
          ? "border-fp-cyan/50 bg-gradient-to-br from-fp-cyan/10 to-transparent"
          : "border-white/10 bg-fp-surface/40"
      } backdrop-blur-sm tracing-border group hover:-translate-y-2 transition-transform duration-500`}
    >
      <div className="text-[11px] tracking-[0.3em] uppercase text-fp-cyan/80 font-heading font-semibold">
        {year}
      </div>
      <div className="mt-4 font-heading font-black text-6xl md:text-7xl silver-gradient leading-none">
        {n.toLocaleString("it-IT")}
      </div>
      <div className="mt-3 text-white/70 text-sm md:text-base">{label}</div>
      {highlight && (
        <div className="absolute top-6 right-6 px-3 py-1 rounded-full border border-fp-cyan bg-fp-cyan/20 text-fp-cyan text-[10px] font-heading font-bold tracking-[0.2em] uppercase">
          Target
        </div>
      )}
    </motion.div>
  );
}

export default function GrowthStats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  return (
    <section ref={ref} className="relative py-24 md:py-32 px-5 md:px-8" data-testid="growth-stats">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <div className="text-xs tracking-[0.4em] uppercase text-fp-cyan font-heading font-semibold">
            La nostra crescita
          </div>
          <h2 className="mt-4 font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tight">
            <span className="silver-gradient">Una community</span>{" "}
            <span className="cyan-gradient">in espansione</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-2xl mx-auto">
            Edizione dopo edizione, sempre più partecipanti si uniscono al torneo più elettrico d'Italia.
          </p>
        </motion.div>

        <div className="grid gap-5 md:gap-6 max-w-xl mx-auto">
          <Card year="Edizione 2026/2027" value={950} label="Partecipanti iscritti" inView={inView} delay={0} />
        </div>
      </div>
    </section>
  );
}
